import { autoserialize } from 'cerialize';

export class TransitProgramAvailability {
  @autoserialize
  areTransitProgramsAvailable: boolean;

  @autoserialize
  areTransitProgramsAcceptingDrivers: boolean;
}
